import React from 'react';
import { Controller } from 'react-hook-form';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import AdminPage from '../../components/admin/AdminPage';
import useProjectAmenity from './hooks/useProjectAmenity';
import LoadingCard from '../../components/LoadingCard';
import SweetAlert from 'react-bootstrap-sweetalert';

const ProjectConfigAmenity = () => {
  const pageName = 'Amenidades';
  const pageParentName = 'Inversiones';
  const {
    results,
    handleEdit,
    handleSubmit,
    onSubmit,
    control,
    errors,
    editingId,
    reset,
    setEditingId,
    isLoading,
    sweetAlert,
    alertProps,
    searchQuery,
    setSearchQuery,
    filteredResults,
  } = useProjectAmenity();

  if (isLoading)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage name={pageName} parentName={pageParentName}>
      {sweetAlert && (
        <SweetAlert {...alertProps}>{alertProps.text || ''}</SweetAlert>
      )}
      <Row>
        {/* Table Column */}
        <Col md="6">
          <h5>Resultados</h5>
          <Input
            type="text"
            placeholder="Buscar por nombre"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="mb-3"
          />
          <div
            style={{
              height: '500px',
              overflow: 'auto',
            }}
          >
            <Table className="align-items-center" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredResults.length > 0 ? (
                  filteredResults.map((result) => (
                    <tr key={result.id}>
                      <td>{result.description}</td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-secondary"
                            href="#"
                            role="button"
                            size="sm"
                            color=""
                            caret
                            onClick={(e) => e.preventDefault()}
                          >
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-arrow" right container='body'>
                            <DropdownItem onClick={() => handleEdit(result.id)}>
                              Editar
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No hay resultados que coincidan con la búsqueda
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>

        {/* Form Column */}
        <Col md="6">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Label for="description">Nombre</Label>
              <Controller
                name="description"
                control={control}
                rules={{
                  required: 'El nombre es obligatorio',
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    id="description"
                    type="text"
                    placeholder="Ingrese el nombre de la amenidad"
                    className={errors.description ? 'is-invalid' : ''}
                  />
                )}
              />
              {errors.description && (
                <div className="text-danger">{errors.description.message}</div>
              )}
            </FormGroup>
            <Button color="primary" type="submit">
              {editingId !== null ? 'Actualizar' : 'Guardar'}
            </Button>
            {editingId !== null && (
              <Button
                color="secondary"
                type="button"
                onClick={() => {
                  reset();
                  setEditingId(null);
                }}
                className="ms-2"
              >
                Cancelar
              </Button>
            )}
          </Form>
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ProjectConfigAmenity;
